import React from 'react'
import { DndContext, closestCenter, PointerSensor, useSensor, useSensors } from '@dnd-kit/core'
import { arrayMove, SortableContext } from '@dnd-kit/sortable'
import PlannedConsultationEditorFormMedia from './PlannedConsultationEditorMedia'

/**
 *
 * @documentation {dnd-kit} https://docs.dndkit.com/presets/sortable
 */
const PlannedConsultationEditorMediaListSortable = ({
    medias,
    onReorder,
    onPreview,
    onRenameRequest,
    onDeleteRequest,
}: any) => {
    const sensors = useSensors(
        useSensor(PointerSensor, {
            activationConstraint: {
                distance: 8,
            },
        })
    )

    const handleDragEnd = (event: any) => {
        const { active, over } = event

        if (active.id !== over.id) {
            const oldIndex = medias.map((media: any) => media.id).indexOf(active.id)
            const newIndex = medias.map((media: any) => media.id).indexOf(over.id)

            const reordored = arrayMove(medias, oldIndex, newIndex)
            onReorder(reordored)
        }
    }

    return (
        <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
            <SortableContext items={medias}>
                {medias.map((media: any) => (
                    <PlannedConsultationEditorFormMedia
                        key={media.id}
                        media={media}
                        onPreview={onPreview}
                        onRenameRequest={onRenameRequest}
                        onDeleteRequest={onDeleteRequest}
                    />
                ))}
            </SortableContext>
        </DndContext>
    )
}

export default PlannedConsultationEditorMediaListSortable
